<div class="p-12">

    <h1 style=" ">
      <strong>HELP - HOW TO USE FILTERS</strong>
    </h1>

  <br>
  <p>
    In this guide, we'll walk you through the process of accessing and utilizing
    filters effectively within our website's different categories, such as
    laptops, monitors, accessories, and more. By mastering these filter
    functionalities, you'll be able to quickly locate the perfect computer or
    accessory that matches your preferences and requirements. Let's dive in and
    discover how to use filters like a pro!
  </p>
  <p>
    මෙම මාර්ගෝපදේශය තුළ, ලැප්ටොප්, මොනිටර, උපාංග සහ තවත් බොහෝ දේ වැනි අපගේ වෙබ්
    අඩවියේ විවිධ කාණ්ඩ තුළ ඵලදායී ලෙස පෙරහන් වෙත ප්‍රවේශ වීමේ සහ භාවිත කිරීමේ
    ක්‍රියාවලිය හරහා අපි ඔබව ගෙන යන්නෙමු. මෙම පෙරහන් ක්‍රියාකාරීත්වයන් ප්‍රගුණ
    කිරීමෙන්, ඔබට ඔබේ අවශ්‍යතාවලට ගැලපෙන පරිපූර්ණ පරිගණකයක් හෝ උපාංගයක් ඉක්මනින්
    සොයා ගැනීමට හැකි වනු ඇත. මෙම පෙරහන් භාවිතා කරන්නේ කෙසේදැයි සොයා බලමු!
  </p>
  <ul>
    <li>
      Filters are typically available within each category, allowing you to
      refine your search based on specific criteria. Therefore, selecting one of
      those categories will open up the filter pane.
    </li>
  </ul>
  <ul>
    <li>
      පෙරහන් සාමාන්‍යයෙන් එක් එක් කාණ්ඩය තුළ ලබා ගත හැකි අතර, විශේෂිත නිර්ණායක
      මත පදනම්ව ඔබේ සෙවුම පිරිපහදු කිරීමට ඔබට ඉඩ සලසයි. එබැවින්, එම වර්ග වලින්
      එකක් තෝරාගැනීමෙන් පෙරහන් කවුළුව විවෘත කරනු ඇත.
    </li>
  </ul>
  <br>
  <ol>
    <li>Accessing Filters:</li>
  </ol>
  <p>
    <strong></strong>
    <strong>පෙරහන් වෙත ප්‍රවේශ වීම:</strong>
  </p>
  <ul>
    <li>
      Start by navigating to the desired category, such as "Laptops" or
      "Monitors."
    </li>
  </ul>
  <p>
    "ලැප්ටොප්" හෝ "මොනිටර" වැනි අපේක්ෂිත පිටුව වෙත ප්‍රවේශ&nbsp; කිරීමෙන් ආරම්භ
    කරන්න.
  </p>
  <br>
  <ol>
    <li>Choosing Filter Options:</li>
  </ol>
  <p>
    <strong>පෙරහන් විකල්ප තේරීම:</strong>
  </p>
  <p>
    Once you access the desired category, you'll see different options based on
    the category. For laptops, common filters might include:
  </p>
  <p>
    ඔබ අපේක්ෂිත පිටුවට ප්‍රවේශ වූ පසු, පිටුව මත පදනම්ව ඔබට විවිධ විකල්ප පෙනෙනු
    ඇත. ලැප්ටොප් සඳහා, පොදු පෙරහන් ඇතුළත් විය හැකිය:
  </p>
  <ul>
    <li>
      Price range: Set your budget by selecting a minimum and maximum price.
    </li>
  </ul>
  <p>මිල පරාසය: අවම සහ උපරිම මිලක් තේරීමෙන් ඔබට අවශ්‍ය මිල ප්‍රමාණය සකසන්න.</p>
  <ul>
    <li>Brand: Filter by brands like HP, Dell, Apple, etc.</li>
  </ul>
  <p>වෙළඳ නාමය: HP, Dell, Apple වැනි වෙළඳ නාම අනුව පෙරහන් කරන්න</p>
  <ul>
    <li>Processor: Choose the processor type (e.g., Intel Core i5).</li>
  </ul>
  <p>ප්‍රොසෙසරය: ප්‍රොසෙසර වර්ගය තෝරන්න (උදා: Intel Core i5).</p>
  <ul>
    <li>RAM: Select the amount of RAM you need (e.g., 8GB, 16GB).</li>
  </ul>
  <p>RAM: ඔබට අවශ්‍ය RAM ප්‍රමාණය තෝරන්න (උදා: 8GB, 16GB).</p>
  <br>
  <ol>
    <li>Applying Filters:</li>
  </ol>
  <p>
    <strong>පෙරහන් යෙදීම:</strong>
  </p>
  <ul>
    <li>
      Selecting the filter options will automatically shortlist only the
      products that match your chosen criteria.
    </li>
  </ul>
  <p>
    පෙරහන් විකල්ප තේරීම ඔබ තෝරාගත් නිර්ණායකයට ගැලපෙන නිෂ්පාදන පමණක් ස්වයංක්‍රීයව
    ලැයිස්තුගත කරයි.
  </p>
  <p>
    By following these steps, you can effectively use filters on our website to
    find products that meet your specific requirements.
  </p>
  <p>
    මෙම පියවර අනුගමනය කිරීමෙන්, ඔබට ඔබේ නිශ්චිත අවශ්‍යතා සපුරාලන නිෂ්පාදන සොයා
    ගැනීමට අපගේ වෙබ් අඩවියේ ෆිල්ටර ඵලදායී ලෙස භාවිතා කළ හැක.
  </p>
</div>
<app-footer></app-footer>